<template>
  <FlotoDrawer :open="isOpen" :scrolled-content="false" @hide="isOpen = false">
    <template v-slot:trigger>
      <a @click="isOpen = true">
        <slot />
      </a>
    </template>
    <template v-slot:title>
      {{ errors.length }}
      {{
        $t('bulk_update_error', { resource: $tc(moduleName, errors.length) })
      }}
    </template>
    <FlotoScrollView>
      <ResizableTable sticky-headers :use-scroll="false">
        <table class="item-list-table w-full">
          <thead>
            <tr>
              <td class="sticky">
                {{ $tc(moduleName) }}
              </td>
              <td class="sticky">{{ $t('error') }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="error in errors" :key="error.id">
              <!-- eslint-disable-next-line -->
              <td class="text-ellipsis">
                <ResourceListTitle
                  :name="error.name"
                  :subject="error.subject"
                  open-in-new-tab
                  external-link
                  :link="
                    $currentModule.getRoute('view', {
                      params: { ticketType: moduleName, id: error.id },
                    })
                  "
                />
              </td>
              <td class="text-ellipsis">
                {{ error.message }}
              </td>
            </tr>
          </tbody>
        </table>
      </ResizableTable>
    </FlotoScrollView>
    <template v-slot:actions="{ hide }">
      <MButton variant="default" @click="hide">
        {{ $t('close') }}
      </MButton>
    </template>
  </FlotoDrawer>
</template>

<script>
import ResizableTable from '@components/table/resizable-table'
import ResourceListTitle from '@components/resource/resource-list-title'

export default {
  name: 'BulkUpdateErrorDrawer',
  components: { ResizableTable, ResourceListTitle },
  props: {
    errors: { type: Array, required: true },
    moduleName: { type: String, required: true },
  },
  data() {
    return {
      isOpen: false,
    }
  },
}
</script>
